<template>
    <views class="loading">
        <van-loading :color="color" />
    </views>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#1989fa'
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
